import {Dispatch, useEffect, useReducer } from "react";
import { headerReducer, initialHeaderState } from "../state/Reducers";
import { useBatteryService } from "../hooks/useBatteryService";
import { useNetworkService } from "../hooks/useNetworkService";
import { Header, LanguageSwitchType } from "@npd-ng/adp-benchmark";
import LowBatterWarning from "./BatteryWarning";
import { Content } from "../types/Content";
import { IADPState, actions } from "../state";
import { IADPActions } from "../state/Actions";
import { useContentService } from "../hooks/useContentService";

export default function AppHeader(props:{dispatch:Dispatch<IADPActions>,state: IADPState}){
    const [headerState, dispatchHeader] = useReducer(headerReducer, initialHeaderState);
    const {fetchContent}= useContentService(props.dispatch);
    const content = props.state.staticContent as Content;
        useBatteryService(dispatchHeader);
       useNetworkService(props.dispatch,props.state,dispatchHeader);
    const onExit = ()=>{
        window.close();
    };
    const onLanguageSwitch = (locale:LanguageSwitchType["selectedLocale"])=>{
        console.log("languageSwitch",locale);
        dispatchHeader(actions.createSetSelectedLocaleAction(locale as any));
        fetchContent(locale);
    };
    const languageProps:LanguageSwitchType = {
    selectedLocale:headerState.selectedLocale,
    content:{instructions:content?.language?.instructions,
    switch: {englishVersion: content?.language?.english, spanishVersion:content?.language?.spanish},
    },
    action:onLanguageSwitch
    }
    return (
        <>
        <LowBatterWarning 
        content = {content} 
        showBatteryWarning = {headerState.showBatteryWarning}
        dispatch = {dispatchHeader}
        />   
        <Header 
        ConnectionState={headerState.networkConnectionState} 
        BatteryLevel={headerState.batteryState} exitAction={onExit}
        LanguageSwitch={languageProps}
        />
        </>
    )
}